module.exports = __webpack_public_path__ + "static/media/1_006.8d209275.jpeg";